"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./src/currency-mask.directive"));
__export(require("./src/currency-mask.module"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/ng2-currency-mask/index.js
// module id = ../../../../ng2-currency-mask/index.js
// module chunks = 3